import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { AppState } from '../../app/state/AppState';
import { Messages } from '../../codegen/Localize';
import { isAlertSuspended, isEditOrResumeEnabled } from '../../spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';
import { dataAlertEdit } from '../actions/menuActions/DataAlertMenuActions';
import { IDataAlertInfo } from '../models/IDataAlertInfo';

export const DataAlertEditAction: IEntityAction<IDataAlertInfo, {}> = {
  name: EntityActionNames.Edit,
  translateName: Messages.editDataAlert_action,
  isVisible: (targetItems: IDataAlertInfo[]) => {
    return !isAlertSuspended(targetItems);
  },
  isClickable: (_availableActions: {}, targetItems: IDataAlertInfo[], state: AppState) => {
    return isEditOrResumeEnabled(state, targetItems);
  },
  createReduxAction: (targetItems: IDataAlertInfo[]) => dataAlertEdit(targetItems)
};
